<template>
  <div class="d-flex wrap-textbox">
    <span @click="callMethod">
      <BaseIcon
        :name="name"
        :width="width"
        :height="height"
        class="icon-right-flot"
      />
    </span>
    <slot />
  </div>
</template>
<style lang="scss">
.input-text-icon input {
  padding-right: 25px !important;
}
.icon-right-flot {
  z-index: 2;
  position: absolute;
  right: 10px;
  top: 17%;
}
.wrap-textbox {
  position: relative;
  width: 100%;
  input {
    padding-right: 25px !important;
  }
}
</style>
<script>
import BaseIcon from '@/components/BaseIcon.vue';
export default {
  components: { BaseIcon },
  props: {
    name: '',
    color: '',
    width: '',
    height: '',
  },
  methods: {
    callMethod() {
      this.$emit('Onclick');
    },
  },
};
</script>
